

<template>
	<section class="clearfix">
		<compWrapper title="权限菜单" theme="primary" class="pull-left width-40per">
			<componentNode class="margin-left-15 margin-top-15" @on-data="getNodeData" />
		</compWrapper>
		<vAffix :offsetTop="60" class="pull-right width-60per">
			<compWrapper title="基本信息" theme="primary" class="margin-left-20">
				<compFormEdit :formdata="getBase" v-model="formData" ref="form" class="margin-15"></compFormEdit>
				<footer class="text-center" v-if="operateType=='add'||operateType=='edit'">
					<vButton theme="primary" @click="updateMenu" class="margin-right-15">保存</vButton>
					<vButton @click="cancel">重置</vButton>
				</footer>
			</compWrapper>
		</vAffix>
		<vLoading size="large" transfer loading v-if="loading"></vLoading>
	</section>
</template>

<script>
import componentNode from './node';
import {
	HttpGlobalDataList,
	HttpUpdateMenu,
	HttpAddMenu,
	HttpMenuDetail,
	HttpDelMenu,
	HttpDdSystems,
	HttpMoveMenu
} from '@/service/ucadm';
import iconsList from "./icons";
import { mapGetters } from 'vuex';
export default {
	components: {
		componentNode,
	},
	data() {
		return {
			isSystem: false,
			loading: false,
			systemData: [],
			modelsData: [],
			operateType: '',
			formData: {
				title: "",
				langKey: "",
				labelId: "",
				iconClass: "",
				scope: "0",
				url: "",
				menuType: "0",
				verifyType: "0",
				systemType: "0",
				globalCatelogId: "0"
			},
		};
	},
	watch: {
		"formData.labelId": function () {
			this.formData.langKey = this.formData.labelId
		}
	},
	computed: {
		...mapGetters(['isSuper']),
		getBase() {
			const radioOpts = [{
				trueValue: '1',
				label: '是'
			}, {
				trueValue: '0',
				label: '否'
			}]
			return [{
				label: '菜单名称',
				key: 'title',
			}, {
				label: '权限唯一标识',
				key: 'labelId',
				formItem: {
					rules: [{
						required: true,
						message: '该信息不能为空,请填写'
					}, {
						validator(rule, value, callback) {
							if (!value || !/^(\w+\.){2}\w+$/ig.test(value)) {
								callback(new Error('不符合xxx.xxx.xxx([项目].[模块].[属性])的格式规范'));
							} else {
								callback();
							}
						}
					}]
				}
			}, {
				label: '多语言标识',
				key: 'langKey',
				query: true
				// formItem: {
				// 	rules: [{
				// 		required: true,
				// 		message: '该信息不能为空,请填写'
				// 	}, {
				// 		validator(rule, value, callback) {
				// 			if (!value || !/^(\w+\.)+\w+$/i.test(value)) {
				// 				callback(new Error('不符合xxx.xxx.xxx([项目].[模块].[属性])的格式规范'));
				// 			} else {
				// 				callback();
				// 			}
				// 		}
				// 	}]
				// }
			}, {
				label: '图标样式',
				key: 'iconClass',
				required: false,
				children(h) {
					return iconsList.map(function (item) {
						return <vOption value={item}><vIcon type={item}></vIcon> {item}</vOption>
					})
				},
				props: {
					filterable: true
				},
			}, {
				label: '所属系统',
				key: 'scope',
				tag: 'vSelect',
				options: this.systemData,
				required: false,
				props: {
					dropStyle: {
						width: 'auto'
					}
				}
			}, {
				label: '链接地址',
				key: 'url',
				required: false,
			}, {
				label: '全局菜单分类',
				key: 'globalCatelogId',
				tag: 'vSelect',
				options: this.modelsData,
				show: this.isSystem,
				required: false,
				props: {
					dropStyle: {
						width: 'auto'
					}
				}
			}, {
				label: '作为菜单',
				key: 'menuType',
				tag: "vRadio",
				options: radioOpts,

			}, {
				label: '验证权限',
				key: 'verifyType',
				tag: "vRadio",
				options: radioOpts,
			}, {
				label: '系统菜单',
				key: 'systemType',
				tag: "vRadio",
				options: radioOpts,
				show: this.isSystem,
				required: false,
			},
			]
		},
	},
	created() {
		const state = this.$store.state.userinfo;
		this.isSystem = state.isOps == 1 || this.isSuper;
		this.getDdSystems();
	},

	methods: {
		cancel() {
			this.formData = {};
			this.$refs.form.resetFields();
		},
		updateNodes() {
			this.loading = true;
			this.$store.dispatch('ucadm/actionAuthmenu', true).finally(() => {
				this.loading = false;
			});
		},
		// ...mapActions('ucadm',['actionBase']),
		getNodeData(data = {}, type) {
			if (type === 'move') return this.moveMenu(data);
			let {
				title = "", langKey = "", labelId = "", iconClass = "", scope = "0", url = "", menuType = "0", verifyType = "0", parentId = '', systemType = "0", globalCatelogId = "0"
			} = data;
			this.formData = {
				title,
				langKey,
				labelId,
				iconClass,
				scope,
				url,
				menuType,
				verifyType,
				parentId,
				systemType,
				globalCatelogId
			};
			this.operateType = type;
			if (type === 'add') return;
			if (type === 'edit') {
				this.formData.id = data.id;
				this.formData.menuType = this.formData.menuType === 'YES' ? '1' : '0';
				this.formData.verifyType = this.formData.verifyType === 'YES' ? '1' : '0';
				this.formData.systemType = this.formData.systemType === 'YES' ? '1' : '0';
				return;
			}
			if (type === 'delete') {
				this.formData = data;
				this.$VModal.warning({
					title: "删除该菜单",
					content: "<div class='margin-5 text-center'>确定删除该菜单？</div>",
					async: true,
				}, {
					'on-after-close': () => {
						this.$VModal.destroy();
					},
					'on-confirm': this.deleteMenu
				}
				)
			}
		},
		async updateMenu() {
			let vaild = await this.$refs.form.validate();
			if (!vaild) return;
			this.loading = true;
			HttpUpdateMenu(this.formData).then(res => {
				this.loading = false;
				this.$VMessage.success(res.message);
				this.updateNodes();
				this.formData = {};
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
				this.$refs.form.resetFields();
			});
		},
		async deleteMenu(name) {
			HttpDelMenu(this.formData).then(res => {
				this.$VMessage.success(res.message);
				this.updateNodes();
				this.$VModal.destroy();
			}).catch(err => {
				this.$VModal.get(name).loading = false;
				this.$VMessage.error(err.message);
				this.cancel();
			});
		},
		async moveMenu(data) {
			this.loading = true;
			HttpMoveMenu(data).then(res => {
				this.loading = false;
				this.$VMessage.success(res.message);
				this.updateNodes();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
				this.$refs.form.resetFields();
			});
		},
		async getDdSystems() {
			let response = await HttpDdSystems().catch(err => {
				this.$VMessage.error(err.message);
			});
			let res = await HttpGlobalDataList().catch(err => {
				this.$VMessage.error(err.message);
			})
			if (response) {
				this.systemData = (response.data || []).map(function (item) {
					return {
						value: item.id,
						label: `${item.label}(${item.title})`
					}
				});
			}
			if (res) {
				this.modelsData = (res.data.globalcatelogs || []).map(function (item) {
					return {
						value: item.id,
						label: `${item.label}(${item.title})`
					}
				});
				this.modelsData.unshift({ value: '0', label: '无' });
			}
		},
	},
};
</script>
